export const quotes = [
  {
    quote: "Nothing is impossible. The word itself says 'I'm possible!'",
    person: "Audrey Hepburn"
  },
  {
    quote: "We are such stuff as dreams are made on.",
    person: "William Shakespeare"
  },
  {
    quote: "Be yourself; everyone else is already taken.",
    person: "Oscar Wilde"
  },
  {
    quote: "The more I study, the more insatiable do I feel my genius for it to be.",
    person: "Ada Lovelace"
  },
  {
    quote: "Fill your paper with the breathings of your heart.",
    person: "William Wordsworth"
  },
  {
    quote: "The only way to do great work is to love what you do.",
    person: "Steve Jobs"
  },
  {
    quote: "Beware; for I am fearless, and therefore powerful.",
    person: "Mary Shelley"
  },
  {
    quote: "Happiness is not something ready made. It comes from your own actions.",
    person: "Dalai Lama"
  },
  {
    quote: "Beauty begins the moment you decide to be yourself.",
    person: "Coco Chanel"
  },
  {
    quote: "The beginning is the most important part of the work.",
    person: "Plato"
  },
  {
    quote: "Success is not final, failure is not fatal: it is the courage to continue that counts.",
    person: "Winston Churchill"
  },
  {
    quote: "Being powerful is like being a lady. If you have to tell people you are, you aren't.",
    person: "Margaret Thatcher"
  },
  {
    quote: "I believe in pink. I believe that laughing is the best calorie burner.",
    person: "Audrey Hepburn"
  },
  {
    quote: "Pour yourself a drink, put on some lipstick, and pull yourself together.",
    person: "Elizabeth Taylor"
  },
  {
    quote: "The secret to staying young is to live honestly, eat slowly, and lie about your age.",
    person: "Lucille Ball"
  },
  {
    quote: "I am a marvelous housekeeper. Every time I leave a man, I keep his house.",
    person: "Zsa Zsa Gabor"
  },
  {
    quote: "Beauty is how you feel inside, and it reflects in your eyes.",
    person: "Sophia Loren"
  },
  {
    quote: "Life is not a dress rehearsal.",
    person: "Vivien Leigh"
  },
  {
    quote: "Surely it is better to be frivolous than to be bored.",
    person: "Nancy Mitford"
  },
  {
    quote: "What we think, we become.",
    person: "Buddha"
  },
  {
    quote: "A thing of beauty is a joy forever.",
    person: "John Keats"
  }
];
